<template>
  <div>
    <!-- 面包屑导航区域 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{path: '/home'}">首页</el-breadcrumb-item>
      <el-breadcrumb-item>工艺管理</el-breadcrumb-item>
      <el-breadcrumb-item>工序管理</el-breadcrumb-item>
    </el-breadcrumb>
    <el-card>
      <!-- 添加产品类型按钮 -->
      <el-row>
        <el-col>
          <el-button type="success" @click="addDialogVisible = true">新增工序</el-button>
        </el-col>
      </el-row>
      <div>
        <!-- 工序信息表格 -->
        <el-button
          icon="el-icon-download"
          circle
          @click="getpdfyes"
          class="download"
          type="warning"
          size="medium"
        ></el-button>
        <el-table id="pdfDom" :data="processMessageList" border stripe class="123">
          <el-table-column type="index"></el-table-column>
          <el-table-column label="工序编号" prop="ProcessNO"></el-table-column>
          <el-table-column label="工序名称" prop="ProcessName"></el-table-column>
          <el-table-column label="工序内容" prop="ProcessContent"></el-table-column>
          <el-table-column label="是否启用" prop="Is_Use"></el-table-column>
          <el-table-column label="备注" prop="Remark"></el-table-column>
          <el-table-column label="操作">
            <template slot-scope="scope">
              <el-button type="primary" icon="el-icon-edit" size="mini" @click="showEditDialog(scope)">编辑</el-button>
              <el-button type="danger" icon="el-icon-delete" size="mini" @click="removeType(scope)">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <!-- 分页区域 -->
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="getTypeList.page"
        :page-sizes="[5, 10, 15]"
        :page-size="getTypeList.limit"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
      >
      </el-pagination>
    </el-card>

    <!-- 编辑设备的会话框 -->
    <el-dialog title="修改工序信息" :visible.sync="editDialogVisible" width="30%" @close="editDialogClose">
      <el-form :model="editForm" :rules="editFormRules" ref="editFormRef" label-width="100px">
        <el-form-item label="工序编号" prop="ProcessNO" required>
          <el-input v-model="editForm.ProcessNO" style="width: 90%" size="medium"></el-input>
        </el-form-item>
        <el-form-item label="工序名称" prop="ProcessName" required>
          <el-input v-model="editForm.ProcessName" style="width: 90%" size="medium"></el-input>
        </el-form-item>
        <el-form-item label="工序内容" prop="ProcessContent" required>
          <el-input v-model="editForm.ProcessContent" style="width: 90%" size="medium"></el-input>
        </el-form-item>
        <el-form-item label="是否启用" prop="Is_Use" required>
          <el-select v-model="editForm.Is_Use" placeholder="请选择">
            <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value"> </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="备注" prop="Remark">
          <el-input v-model="editForm.Remark" style="width: 90%" size="medium"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="editDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="editProduct">确 定</el-button>
      </span>
    </el-dialog>

    <!-- 添加工序的对话框 -->
    <el-dialog title="新增工序" :visible.sync="addDialogVisible" width="25%" @close="addDialogClosed">
      <!-- 内容主体区域 -->
      <el-form :model="addForm" :rules="addFormRules" ref="addFormRef" label-width="90px">
        <el-form-item label="工序编号" prop="ProcessNO" required>
          <el-input v-model="addForm.ProcessNO" style="width: 90%" size="medium"></el-input>
        </el-form-item>
        <el-form-item label="工序名称" prop="ProcessName" required>
          <el-input v-model="addForm.ProcessName" style="width: 90%" size="medium"></el-input>
        </el-form-item>
        <el-form-item label="工序内容" prop="ProcessContent" required>
          <el-input v-model.number="addForm.ProcessContent" style="width: 90%" size="medium"></el-input>
        </el-form-item>
        <el-form-item label="是否启用" prop="Is_Use" required>
          <el-select v-model="addForm.Is_Use" placeholder="请选择">
            <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value"> </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="备注" prop="Remark">
          <el-input v-model.number="addForm.Remark" style="width: 90%" size="medium"></el-input>
        </el-form-item>
      </el-form>
      <!-- 底部区域 -->
      <span slot="footer" class="dialog-footer">
        <el-button @click="addDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="addProduct">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
    data () {
        return {
            getTypeList: {
                page: 1,
                limit: 5,
                privateKey: '12a5081e-e354-bada-3952-7a0df30d8849',
                appIdentification: 'wms',
                tableName: 'Mes_ProcessSet'
            },
            getTypeList1: {
                page: 1,
                limit: 100,
                privateKey: '12a5081e-e354-bada-3952-7a0df30d8849',
                appIdentification: 'wms',
                tableName: 'Mes_ProcessSet'
            },
            // 工序信息列表
            processMessageList: [],
            // 总数据条数
            total: 0,
            // 控制修改信息对话框的显示与隐藏
            editDialogVisible: false,
            // 控制添加信息对话框的显示与隐藏
            addDialogVisible: false,
            // 编辑用户信息的表单
            editForm: {},
            // 添加用户的表单数据
            addForm: {
                ProcessNO: '',
                ProcessName: '',
                ProcessContent: '',
                Is_Use: '',
                Remark: '',
            },
            //添加表单的验证规则对象
            addFormRules: {
                Address: [
                    { required: true, message: '请输入正确的IP地址', validator: this.validateIP, trigger: 'blur' }
                ],
                Port: [
                    { type: "number", message: '请输入正确的端口号', trigger: 'blur' }
                ]
            },
            // 修改表单的验证规则对象
            editFormRules: {
                Address: [
                    { required: true, message: '请输入正确的IP地址', validator: this.validateIP, trigger: 'blur' }
                ],
                Port: [
                    { type: "number", message: '请输入正确的端口号', trigger: 'blur' }
                ]
            },
            // 是否启用
            options: [{
                value: 'Y',
                label: '是'
            }, {
                value: 'N',
                label: '否'
            }],
        }
    },
    created () {
        this.getType()
        this.getType1()
    },
    methods: {
        // 调用接口获取工序信息
        async getType () {
            const { data: res } = await this.$http.get('/WMS/GeneralQuery', { params: this.getTypeList })
            console.log(res.data)
            for (var i = 0; i < res.data.length; i++) {
                if (res.data[i].Is_Use == 'Y') {
                    res.data[i].Is_Use = '是'
                }
                if (res.data[i].Is_Use == 'N') {
                    res.data[i].Is_Use = '否'
                }
            }
            console.log(res)
            this.processMessageList = res.data
            // console.log(res.data.length)
        },
        // 调用接口获取工序信息
        async getType1 () {
            const { data: res } = await this.$http.get('/WMS/GeneralQuery', { params: this.getTypeList1 })
            console.log(res.data)
            this.total = res.data.length
            // console.log(res.data.length)
        },
        // 调用接口删除工序
        async removeType (scope) {
            const confirmResult = await this.$confirm(
                '此操作将永久删除该设备, 是否继续?',
                '提示',
                {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }
            ).catch(err => err)

            if (confirmResult !== 'confirm') {
                return this.$message.info('已经取消删除！')
            }

            let params = new URLSearchParams();
            params.append("ID", scope.row.ID)
            params.append("tableName", this.getTypeList.tableName)
            params.append("privateKey", this.getTypeList.privateKey)
            params.append("appIdentification", this.getTypeList.appIdentification)
            const { data: res } = await this.$http.post('/WMS/GeneralDelete', params)
            console.log(res)
            if (res !== 1) {
                return this.$message.error('系统异常，删除失败！')
            }
            this.$message.success('删除成功！')
            this.getType()
            this.getType1()
        },
        // 展示修改设备信息的对话框
        async showEditDialog (scope) {
            this.editDialogVisible = true
            let params = new URLSearchParams()
            params.append("ID", scope.row.ID)
            params.append("privateKey", this.getTypeList.privateKey)
            params.append("tableName", this.getTypeList.tableName)
            params.append("appIdentification", this.getTypeList.appIdentification)
            const { data: res } = await this.$http.get('/WMS/GeneralQueryID', { params })
            console.log(res.data)
            this.editForm = res.data[0]
        },
        // 监听修改信息对话框的关闭事件
        editDialogClose () {
            this.$refs.editFormRef.resetFields()
        },
        //  监听添加信息对话框的关闭事件
        addDialogClosed () {
            this.$refs.addFormRef.resetFields()
        },
        // 调用接口新增工序
        addProduct () {
            this.$refs.addFormRef.validate(async valid => {
                if (!valid) return
                let params = new URLSearchParams();
                params.append("privateKey", this.getTypeList.privateKey)
                params.append("appIdentification", this.getTypeList.appIdentification)
                params.append("ProcessNO", this.addForm.ProcessNO)
                params.append("ProcessName", this.addForm.ProcessName)
                params.append("ProcessContent", this.addForm.ProcessContent)
                params.append("Is_Use", this.addForm.Is_Use)
                params.append("Remark", this.addForm.Remark)
                console.log('00' + params)
                const { data: res } = await this.$http.post('/WMS/InsertProcessSet', params)
                console.log(res)
                console.log(res.data)
                if (res !== 1) {
                    return this.$message.error('系统异常,新增失败！')
                }
                this.$message.success('添加工序成功！')
                // 隐藏添加用户的对话框
                this.addDialogVisible = false
                // 重新获取用户列表数据
                this.getType()
                this.getType1()
            })
        },
        // 调用接口编辑工序
        editProduct () {
            this.$refs.editFormRef.validate(async valid => {
                if (!valid) return
                let params = new URLSearchParams();
                params.append("privateKey", this.getTypeList.privateKey)
                params.append("appIdentification", this.getTypeList.appIdentification)
                params.append("ProcessNO", this.editForm.ProcessNO)
                params.append("ProcessName", this.editForm.ProcessName)
                params.append("ID", this.editForm.ID)
                params.append("ProcessContent", this.editForm.ProcessContent)
                params.append("Is_Use", this.editForm.Is_Use)
                params.append("Remark", this.editForm.Remark)
                console.log('123' + params)
                const { data: res } = await this.$http.post('/WMS/updateProcessSet', params)
                console.log(res)
                if (res !== 1) {
                    return this.$message.error('更新工序信息失败！')
                }

                // 关闭对话框
                this.editDialogVisible = false
                // 刷新数据列表
                this.getType()
                this.getType1()
                // 提示修改成功
                this.$message.success('更新设备信息成功！')
            })
        },
        // 监听 pagesize 改变的事件
        handleSizeChange (newSize) {
            console.log('111' + newSize)
            this.getTypeList.limit = newSize
            this.getType()
        },
        // 监听 页码值 改变的事件
        handleCurrentChange (newPage) {
            console.log(newPage)
            this.getTypeList.page = newPage
            this.getType()
        },
        getpdfyes () {
            this.getPdf()
        },
    }
}
</script>

<style lang="less" scoped>
.download {
  position: absolute;
  left: 94%;
  top: 12%;
  transform: translate(50%, 50%);
}
</style>

